//ALWAYS IMPORT ONLY THE COMPONENT YOU NEED FROM MATERIAL
export {
  default as cherreCreateTheme,
  Theme,
} from '@mui/material/styles/createTheme';
export {
  default as CherreThemeProvider,
  ThemeProviderProps as CherreThemeProviderProps,
} from '@mui/material/styles/ThemeProvider';
